<template>
  <div class="main">
    <div
      class="card-header bg-success mx-auto"
      style="color: white; width: 80%"
    >
      TIMELINE
    </div>
    <div>
      <!-- Unavailable for delivery question -->
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4">
          <div class="space">
            <h4>Are There Any Dates You CANNOT Accept Delivery?</h4>
            <h6 style="font-style: italic; font-size: 15px; margin-top: 30px">
              {{ nonAcceptableDateText }}
            </h6>
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card
            color="#ffffff"
            class="question_cards"
            style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
          >
            <div class="question_number">
              <span>5</span>
            </div>
            <div class="mx-auto" style="max-width: 350px">
              <v-date-picker
                v-model="bind_NonAcceptableDates"
                class="mt-4"
                header-color="#00587d"
                color="red"
                reactive
                multiple
                full-width
                :min="minDate()"
                :allowed-dates="allowedDates"
                @input="maintainSessionStorage()"
              ></v-date-picker>
              <v-combobox
                v-model="bind_NonAcceptableDates"
                multiple
                chips
                success
                small-chips
                label="Cannot accept delivery on:"
                prepend-icon="event"
                readonly
              ></v-combobox>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- Unavailable for delivery question ends -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "Timeline",
  data() {
    return {
      today: new Date().toISOString().slice(0, 10),
      date: "",
      dates: [],
      nonAcceptableDateText:
        "We'll request the next available date with the hauler and then you'll receive an email within one (1) business day to confirm that delivery date (please note, we don't deliver on weekends or holidays). Deliveries average 4-7 business days and you'll receive an email once your delivery is scheduled (and the driver will call when they're en route on the day of delivery).",
    };
  },
  computed: {
    ...mapGetters({
      nonAcceptableDates: types.DELIVERY_NONACCEPTABLEDATES,
      predelivery: types.PREDELIVERYANSWERS,
    }),
    bind_NonAcceptableDates: {
      get() {
        return this.nonAcceptableDates;
      },
      set(value) {
        this.updateNonAcceptableDates(value);
      },
    },
  },
  methods: {
    ...mapActions({
      updateNonAcceptableDates:
        types.ACTIONS_UPDATE_DELIVERY_NONACCEPTABLEDATES,
    }),
    maintainSessionStorage() {
      const predelivery = JSON.stringify(this.predelivery);
      sessionStorage.setItem("predelivery", predelivery);
    },
    allowedDates(val) {
      var day = new Date(val);
      var dayOfWeek = day.getDay();
      return dayOfWeek in [1, 2, 3, 4, 5];
    },
    minDate() {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toISOString().slice(0, 10);
    },
  },
};
</script>

<style scoped>
h4 {
  font-size: 24px;
  font-weight: bold;
}

.box {
  color: #00587d;
}

.question_cards {
  padding-top: 30px;
  padding-bottom: 5px;
  margin: 20px;
  padding-left: 5px;
  padding-right: 5px;
  overflow: hidden;
}

.question_number {
  background-color: #6dbe45;
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.8);
  height: 70px;
  left: -50px;
  position: absolute;
  top: -50px;
  width: 100px;
  -webkit-transform: rotate(-45deg);
}

.question_number span {
  color: #f5f5f5;
  font-family: sans-serif;
  font-size: 0.8em;
  left: 5px;
  top: 52px;
  position: absolute;
  width: 70px;
}

@media only screen and (max-width: 400px) {
  v-date-picker {
    max-width: 320px;
  }
}
</style>
